import { getIn } from '../helpers/helpers';
import { BasicElement, DataLayoutPosition, FieldPosition } from '../types/template-types';
import { getParentKeyPath } from './helpers';
import { getField } from './selectors';
import { TemplateClipboard, TemplateState } from './templateeditor-types';

export function generateClipboardFromSelectedState(state: TemplateState): TemplateClipboard {
  const dataLayoutPositionKeyPaths = state.selection?.dataLayoutPositions;
  const fieldPositionKeyPaths = state.selection?.fieldPositions;
  const elementsKeyPaths = state.selection?.elements;

  const clipboard: TemplateClipboard = {
    fields: []
  };

  if (dataLayoutPositionKeyPaths && state.currentTemplateView === 1) {
    clipboard.dataLayoutPositions = [];
    clipboard.sourceSection = getParentKeyPath(getParentKeyPath(dataLayoutPositionKeyPaths[0]));

    for (const dataLayoutPositionKeyPath of dataLayoutPositionKeyPaths) {
      const dataLayoutPosition = getIn<DataLayoutPosition>(state, dataLayoutPositionKeyPath);

      if (dataLayoutPosition) {
        const field = getField(state, dataLayoutPosition.fieldId);

        if (field) {
          // there could be multiple layouts that use the same field, so check if it already is in clipboard
          if (!clipboard.fields.find((f) => f.id === field.id)) {
            clipboard.fields.push(field);
          }

          clipboard.dataLayoutPositions.push(dataLayoutPosition);
        }
      }
    }
  }

  if (fieldPositionKeyPaths && state.currentTemplateView === 0) {
    clipboard.fieldPositions = [];
    clipboard.sourcePage = getParentKeyPath(getParentKeyPath(fieldPositionKeyPaths[0]));

    for (const fieldPositionKeyPath of fieldPositionKeyPaths) {
      const fieldPosition = getIn<FieldPosition>(state, fieldPositionKeyPath);

      if (fieldPosition) {
        const field = getField(state, fieldPosition.fieldId);

        if (field) {
          // there could be multiple layouts that use the same field, so check if it already is in clipboard
          if (!clipboard.fields.find((f) => f.id === field.id)) {
            clipboard.fields.push(field);
          }

          clipboard.fieldPositions.push(fieldPosition);
        }
      }
    }
  }

  if (elementsKeyPaths && state.currentTemplateView === 0) {
    clipboard.elements = [];
    clipboard.sourcePage = getParentKeyPath(getParentKeyPath(elementsKeyPaths[0]));

    for (const elementKeyPath of elementsKeyPaths) {
      const element = getIn<BasicElement>(state, elementKeyPath);
      clipboard.elements.push(element);
    }
  }

  return clipboard;
}
